module.exports = __webpack_public_path__ + "static/media/item_6_10_comp.adc29973.png";